import { defineMessages } from "react-intl";

export const messages = defineMessages({
    feedbackTitle: {
        id: "fastshift.feedback-collector.feedback-title",
        defaultMessage: "Help us improve FastShift Portal",
        description: "Title for the feedback collector"
    },
    feedbackTitleDetails: {
        id: "fastshift.feedback-collector.feedback-title-details",
        defaultMessage:
            "We’d love to hear about your experience using FastShift Portal. ",
        description: "Details for the feedback collector title"
    }
});
